import { AppContext } from '@/lib/core/types/modules';
import {
  ApiBlockListModel,
  ContentPropertiesModel,
  IApiContentResponseModel,
} from '@/services/platform/api/model';
import { ScreenHead } from '../../screen/head';
import { ModulesRow } from '@/components/modules/row';
import { cn, useClientTranslation } from '@/lib/core';
import { useNavigate } from 'react-router-dom';
import { ShopHeaderActions } from '@/components/shared/shop/layout/ShopHeaderActions';

interface ShopDiscoverProps {
  content: IApiContentResponseModel;
  context?: AppContext;
}

export function ShopDiscover({ content, context }: ShopDiscoverProps) {
  const navigate = useNavigate();
  const t = useClientTranslation();

  return (
    <div className="pb-safe-area relative w-full">
      <div className="relative w-full">
        <div
          className={cn(
            'pt-safe-area fixed top-0 z-80 flex w-full',
            'bg-linear-to-b from-black/80 to-transparent pb-4 backdrop-blur-[2.5px]'
          )}
        >
          <ScreenHead
            title={content?.name ?? ''}
            onBack={() => navigate(-1)}
            ariaLabel={t('App.Labels.GoBack')}
            variant={'overlay'}
            className="pt-0"
            rightActions={<ShopHeaderActions context={context} showHeroCarousel={true} />}
          />
        </div>
      </div>
      <ModulesRow
        components={
          (content?.properties as ContentPropertiesModel)?.components as ApiBlockListModel | undefined
        }
        context={context}
      />
    </div>
  );
}
